import { render } from "./CloneDeckModal.vue?vue&type=template&id=e0c860f8&scoped=true&ts=true"
import script from "./CloneDeckModal.vue?vue&type=script&lang=ts"
export * from "./CloneDeckModal.vue?vue&type=script&lang=ts"

import "./CloneDeckModal.vue?vue&type=style&index=0&id=e0c860f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c860f8"]])

export default __exports__